import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=1a37ad2e&scoped=true&"
import script from "./SettingsPage.vue?vue&type=script&lang=js&"
export * from "./SettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37ad2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a37ad2e')) {
      api.createRecord('1a37ad2e', component.options)
    } else {
      api.reload('1a37ad2e', component.options)
    }
    module.hot.accept("./SettingsPage.vue?vue&type=template&id=1a37ad2e&scoped=true&", function () {
      api.rerender('1a37ad2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/SettingsPage.vue"
export default component.exports